import React, { useEffect, useState } from "react";
import styles from "./business-profile.module.css";
import LeftArrow from "../Icons/left-arrow";
import { useDispatch, useSelector } from "react-redux";
import { LEFT_SIDE_BAR_SELECTED } from "../EnterprisePortal/leftNavbar";
import { ACCOUNTS_COMPONENT } from "../Accounts/AccountsWrapper";
import { CompanyInfoCard } from "./CompanyInfoCard";
import { cx } from "../../Util/classHelpers";
import { activeCompanySelector, CLEAR_ACTIVE_COMPANY } from "../../Reducers/activeCompanyReducer";
import QuickStatsTab from "./QuickStatsTab";
import { companyReviewSummarySelector } from "../../Reducers/companyReviewSummaryReducer";
import { companyAiInsightsSelector } from "../../Reducers/companyAiInsightsReducer";
import { getCompanyAiInsights } from "../../Actions/companyAiInsightActions";
import { getCompanyReviewSummary } from "../../Actions/companyReviewSummaryActions";
import ReviewsTab from "./ReviewsTab";
import AiInsightsTab from "./AiInsightsTab";
import BillingTab from "./BillingTab";
import { fullScreenLayoutSelector, SET_LAYOUT_FULL_SCREEN } from "../../Reducers/selectedComponentReducer";
import { ownPermissionsSelector } from "../../Reducers/ownRoleReducer";

const BUSINESS_PROFILE = "BUSINESS_PROFILE";

const Header = () => {
    const dispatch = useDispatch();

    const handleBack = () => {
        dispatch({ type: CLEAR_ACTIVE_COMPANY });
        dispatch({ type: LEFT_SIDE_BAR_SELECTED, payload: ACCOUNTS_COMPONENT });
    }

    return (
        <div className={styles.header}>
            <div className={styles.headerAvatar} onClick={handleBack}>
                <LeftArrow />
            </div>
            <div className={styles.headerTitle}>Business profile</div>
        </div>
    )
}

const allTabs = [
    {
        title: "Quick stats",
        component: QuickStatsTab
    },
    {
        title: "Reviews",
        component: ReviewsTab
    },
    {
        title: "AI insights",
        component: AiInsightsTab
    },
    {
        title: "Billing",
        component: BillingTab,
        requiresBillingPermission: true
    },
    // {
    //     title: "Preferences",
    //     component: () => <div>Preferences</div>
    // }
]

const BusinessProfilePageWrapper = () => {
    const activeCompanyId = useSelector(activeCompanySelector);
    const companyReviewSummary = useSelector(companyReviewSummarySelector);
    const companyAiInsights = useSelector(companyAiInsightsSelector);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const fullScreen = useSelector(fullScreenLayoutSelector);
    const ownPermissions = useSelector(ownPermissionsSelector);
    const dispatch = useDispatch();

    // Filter tabs based on permissions
    const tabs = allTabs.filter(tab => {
        if (tab.requiresBillingPermission) {
            return ownPermissions?.canReadBilling() ?? false;
        }
        return true;
    });

    // Ensure activeTabIndex is within bounds after filtering
    const safeActiveTabIndex = Math.min(activeTabIndex, tabs.length - 1);
    const Component = tabs[safeActiveTabIndex]?.component;

    // Reset activeTabIndex if it's out of bounds after filtering
    useEffect(() => {
        if (activeTabIndex >= tabs.length) {
            setActiveTabIndex(0);
        }
    }, [tabs.length, activeTabIndex]);

    useEffect(() => {
        dispatch({ type: SET_LAYOUT_FULL_SCREEN, payload: true });
        return () => {
            dispatch({ type: SET_LAYOUT_FULL_SCREEN, payload: false });
        }
    }, [dispatch]);

    useEffect(() => {
        if (activeCompanyId && companyAiInsights.getCompanyId() !== activeCompanyId) {
            dispatch(getCompanyAiInsights(activeCompanyId));
        }
    }, [activeCompanyId, companyAiInsights, dispatch]);

    useEffect(() => {
        if (activeCompanyId && companyReviewSummary.getCompanyId() !== activeCompanyId) {
            dispatch(getCompanyReviewSummary(activeCompanyId));
        }
    }, [activeCompanyId, companyReviewSummary, dispatch]);


    if (activeCompanyId === null || !fullScreen) {
        return null;
    }

    return (
        <div className={styles.root}>
            <Header />
            <div className={styles.main}>
                <CompanyInfoCard />

                <div className={styles.tabsContainer}>
                    <div className={styles.tabs}>
                        {tabs.map((tab, index) => (
                            <button key={index} className={cx(styles.tab, index === safeActiveTabIndex && styles.tabActive)} onClick={() => setActiveTabIndex(index)}>{tab.title}</button>
                        ))}
                    </div>

                    <div className={styles.tabContent}>
                        {Component && <Component />}
                    </div>
                </div>            
            </div>
        </div>
    );
};

export default BusinessProfilePageWrapper;
export { BUSINESS_PROFILE };
